import { httpRequest } from './http-client';
import type { HttpRequestOptions } from './types';

export const http = {
  get<T>(url: string, options?: HttpRequestOptions & { params?: any }) {
    return httpRequest<T>('GET', url, options?.params, options);
  },
  post<T>(url: string, payload?: any, options?: HttpRequestOptions) {
    return httpRequest<T>('POST', url, payload, options);
  },
};
